const tabHeads = document.querySelectorAll(".tab__head");
const tabContents = document.querySelectorAll(".product__tab__content");

tabHeads.forEach((head) => {
  head.addEventListener("click", function () {
    tabHeads.forEach((h) => h.classList.remove("active"));
    tabContents.forEach((c) => c.classList.remove("active"));

    const tabId = head.getAttribute("for");
    head.classList.add("active");
    document.getElementById(tabId).classList.add("active");
  });
});

if (tabHeads.length > 0 && tabContents.length > 0) {
  tabHeads[0].classList.add("active");
  tabContents[0].classList.add("active");
}

document.addEventListener("DOMContentLoaded", (event) => {
  document.querySelectorAll(".modal__close").forEach((element) => {
    element.addEventListener("click", function (event) {
      document
        .querySelectorAll(".selection__modal__overlay")
        .forEach((element) => element.classList.add("hidden"));
    });
  });
});
